export const convertDateStringToUIDate = (dateString: string) => {
  const date: Date = new Date(dateString);
  const UIDate = date.toLocaleDateString("PL-pl", {
    year: "numeric",
    month: "long",
  });
  return UIDate;
};
